import * as THREE from 'three';
import { html } from 'lit';
import { WebGLElement } from './base.js';

export class ThreeMesh extends WebGLElement {
  constructor() {
    super();
    this._matEl = null;
    this._geoEl = null;
    this._matListener = null;
    this._geoListener = null;
  }

  defaultGeometry() {
    return new THREE.BoxGeometry(1, 1, 1);
  }

  defaultMaterial() {
    return new THREE.MeshStandardMaterial({ color: 0xcccccc });
  }

  createObject3D() {
    return new THREE.Mesh(this.defaultGeometry(), this.defaultMaterial());
  }

  render() {
    return html`
      <slot name="material" @slotchange=${this._onMatSlot}></slot>
      <slot name="geometry" @slotchange=${this._onGeoSlot}></slot>
      <slot></slot>
    `;
  }

  firstUpdated() {
    const matSlot = this.renderRoot.querySelector('slot[name="material"]');
    const geoSlot = this.renderRoot.querySelector('slot[name="geometry"]');
    if (matSlot) this._syncMaterial(matSlot);
    if (geoSlot) this._syncGeometry(geoSlot);
  }

  _onMatSlot(e) {
    this._syncMaterial(e.target);
  }

  _onGeoSlot(e) {
    this._syncGeometry(e.target);
  }

  _syncMaterial(slot) {
    const els = slot.assignedElements({ flatten: true });
    const matEl = els.find(el => 'material' in el);
    if (this._matEl && this._matListener) {
      this._matEl.removeEventListener('material-changed', this._matListener);
    }
    this._matEl = matEl || null;
    if (matEl && matEl.material && this.object3D) {
      this.object3D.material = matEl.material;
      this._matListener = () => {
        if (this.object3D && matEl.material) this.object3D.material = matEl.material;
      };
      matEl.addEventListener('material-changed', this._matListener);
    }
  }

  _syncGeometry(slot) {
    const els = slot.assignedElements({ flatten: true });
    const geoEl = els.find(el => 'geometry' in el);
    if (this._geoEl && this._geoListener) {
      this._geoEl.removeEventListener('geometry-changed', this._geoListener);
    }
    this._geoEl = geoEl || null;
    if (geoEl && geoEl.geometry && this.object3D) {
      if (this.object3D.geometry !== geoEl.geometry) {
        this.object3D.geometry.dispose();
        this.object3D.geometry = geoEl.geometry;
      }
      this._geoListener = () => {
        if (this.object3D && geoEl.geometry && this.object3D.geometry !== geoEl.geometry) {
          this.object3D.geometry.dispose();
          this.object3D.geometry = geoEl.geometry;
        }
      };
      geoEl.addEventListener('geometry-changed', this._geoListener);
    }
  }
}

customElements.define('three-mesh', ThreeMesh);
